import { render, staticRenderFns } from "./InviteManagerSidebar.vue?vue&type=template&id=132b6f08&scoped=true&"
import script from "./InviteManagerSidebar.vue?vue&type=script&lang=js&"
export * from "./InviteManagerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InviteManagerSidebar.vue?vue&type=style&index=0&id=132b6f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b6f08",
  null
  
)

export default component.exports